import * as React from 'react';

import { SvgManager } from 'franke-svg-view';
import { ConfigurationModel, TroughModel, PlateBuilder, Configuration } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';

import './SvgView.scss';
import { connect } from 'react-redux';
import { RequestApiResult } from 'loopback-react-request';
import Configuration3dAlert from '../Alerts/Configuration3dAlert';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export interface SvgViewProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: RequestApiResult<ConfigurationModel>;
  trough: RequestApiResult<TroughModel>;
  userData: GlobalPrivateState['userData'];
}

export interface SvgViewState {
  isInitialized: boolean;
}

export interface SvgViewsvgManagerData {
  configuration?: ConfigurationModel;
  isLoaded: boolean;
  isUpdating: boolean;
  threeData?: {[key: string]: unknown};
  trough?: TroughModel;
}

export class SvgViewPartial extends React.Component<SvgViewProps, SvgViewState> {

  container: React.RefObject<HTMLDivElement>;
  container2: React.RefObject<HTMLDivElement>;
  container3: React.RefObject<HTMLDivElement>;

  svgManager: SvgManager | undefined;
  svgManager2: SvgManager | undefined;
  svgManager3: SvgManager | undefined;

  constructor(props: SvgViewProps) {
    super(props);
    this.container = React.createRef();
    this.container2 = React.createRef();
    this.container3 = React.createRef();
    this.state = {
      isInitialized: false,
    };
    this.updateSvgManager = this.updateSvgManager.bind(this);
    this.initSvgManager = this.initSvgManager.bind(this);
  }

  componentDidMount() {
    const configuration = this.props.configuration.result;
    const trough = this.props.trough.result;

    if (!configuration || !trough) {
      return;
    }
    if (!this.state.isInitialized) {
      this.initSvgManager();
    }
  }
  
  componentDidUpdate() {
    const configuration = this.props.configuration.result;
    const trough = this.props.trough.result;

    if (!configuration || !trough) {
      return;
    }

    if (!this.state.isInitialized) {
      this.initSvgManager();
    }

    if (this.state.isInitialized) {
      this.updateSvgManager();
    } 
  }

  public render() {
    return (
      <div className="partial-three d-flex justify-content w-100 vh-100">
        {this.props.configuration.result && this.props.configuration.result.selectedTrough ? (
          <>
            <LoadingSpinner />
            <div className="svg-view-container w-100 h-100" ref={this.container} />
          </>
        ) : (
          <div className="start-screen w-100">
            <Configuration3dAlert />
            <img className="img-fluid start-screen-img" src={process.env.PUBLIC_URL + '/img/backgrounds/startscreen-grafik.jpg'} />
          </div>
        )}
      </div>
    );
  }

  private get svgManagerData() {
    const {plateBuilder} = this.props;
    
    if (plateBuilder) {
      return JSON.parse(JSON.stringify(plateBuilder.components));
    } else {
      return;
    }
  }
  
  private initSvgManager() {
    if (!this.svgManager && this.svgManagerData) {
      const lang = this.props.userData && this.props.userData.result && this.props.userData.result.lang || 'en';
      const langCode: any = lang.split('-')[0];

      this.svgManager = new SvgManager(this.svgManagerData, 'top', this.container.current, langCode);
      this.svgManager2 = new SvgManager(this.svgManagerData, 'front', this.container2.current, langCode);
      this.svgManager3 = new SvgManager(this.svgManagerData, 'side', this.container3.current, langCode);
    }
    this.updateSvgManager();
    this.setState({isInitialized: true});
  }
  
  private updateSvgManager() {
    if (this.svgManager && this.container && this.svgManagerData && this.svgManagerData) {
      this.svgManager.update(this.svgManagerData);

      if (this.svgManager2 && this.svgManager3) {
        this.svgManager2.update(this.svgManagerData);
        this.svgManager3.update(this.svgManagerData);
      }
    }
  }
}

export const SvgView = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
  trough: state.trough,
  userData: state.userData
}))(SvgViewPartial);

export default SvgView;
